module.exports = __webpack_public_path__ + "img/ico_list.01653122.svg";